<div class="container-fluid p-0">
  <app-header></app-header>
  <div class="row m-0 g-0">
    <div class="col-md-3 p-0">
      <app-folders></app-folders>
    </div>

    <div class="col-md-9 container" style="border-top-left-radius: 15px; border-top-right-radius: 15px; overflow: hidden; margin-top: 0 !important;">
      <div class="card" style="height: 1000px;">
        <div class="card-body">
          <div class="d-flex justify-content-start" style="margin-top: 0 !important;">
            <button type="button" class="btn custom-button" style="margin-bottom:10px ;"   (click)="goBack()">Back</button>
          </div>
         
                   
<!-- new -->
<div class="new-card"
      style="border: 2px solid #4A148C; border-radius: 12px; padding: 10px 20px;background-color: #ffffff; box-shadow: 0 4px 12px rgba(103, 58, 183, 0.1);margin-bottom: 5px; font-family: 'Segoe UI', sans-serif; ">
  <div class="card-content">
    <div class="row d-flex align-items-center justify-content-between flex-wrap" style="gap: 12px; font-size: 15px; color: #333;">
      <div class="col-auto" style="min-width: 180px;">
        <strong style="color: #4A148C;">Study Code:</strong> {{ studyCode }}
      </div>
      <div class="col-auto" style="min-width: 180px;">
        <strong style="color: #4A148C;">Study Name:</strong> {{ studyName }}
      </div>
      <div class="col-auto" style="min-width: 180px;">
        <strong style="color: #4A148C;">Subject Name:</strong> {{ subjectName }}
      </div>
      <div class="col-auto" style="min-width: 180px;">
        <strong style="color: #4A148C;">Site Location:</strong> {{ siteLocation }}
      </div>
    </div>
  </div>
</div>

        
            <div *ngIf="formName === 'Schedule-Activities'" class="card mt-4">
                <div class="card-header d-flex justify-content-between align-items-center">
                    <h5 class="m-0">Schedule-Activities</h5>
                    <!--<button type="button" class="btn custom-button">Create Field</button>-->
                </div>
                <div class="card-body scrollable-container">
                    <form (ngSubmit)="submitForm()" #yourForm="ngForm">
                      <div class="table-wrapper">
                        <div class="table-scroll">
                        <table class="table table-bordered">
                          <thead>
                            <tr>
                                <th>No</th>
                                <th>Activity</th>
                                <th *ngFor="let column of columnNames">{{ column }}</th>
                                <th>Discontinuation</th>
                                <th *ngIf="showDiscontinuationComment">Discontinuation Comment</th>
                              </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let row of formData; let i = index">
                              <td>{{ i + 1 }}</td>
                              <td style="width: 130px;">{{ row.visitName }}</td>
                
                              <td style="width: 150px;" *ngFor="let column of columnNames">
                                <select [(ngModel)]="row[column]" [name]="column + i" class="form-control">
                                  <option *ngFor="let option of statusOptions" [value]="option">{{ option }}</option>
                                </select>
                              </td>
                
                              <td class="text-center">
                                <input type="checkbox" [(ngModel)]="row.isDiscontinued" [name]="'discontinued' + i" (change)="toggleDiscontinuationComment(row)">
                              </td>
                
                              <td *ngIf="row.isDiscontinued">
                                <input type="text" class="form-control" [(ngModel)]="row.discontinuationComment" [name]="'discontinuationComment' + i" placeholder="Enter comment">
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      </div>
                      <div class="text-end">
        <!--<button type="button" class="btn custom-button" (click)="goBack()">Back</button>-->
                        <button type="submit" class="btn custom-button">Submit</button>
                    </div>
                </form>
            </div>
           </div>
          </div>
        </div>
        </div>
        </div>
        </div>